
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kontaktnaya-forma",
      function () {
        return require("private-next-pages/kontaktnaya-forma.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kontaktnaya-forma"])
      });
    }
  